module.exports = __webpack_public_path__ + "img/layer-safe.f0b3423d.svg";